








import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateTimeDuration } from "../../../domain/system";
import { ModelEditableMixin } from "../mixins";
import DateTimePicker from "./DateTimePicker.vue";

@Component({
  components: {
    DateTimePicker,
  },
})
export default class DateTimeDurationPicker extends Mixins(ModelEditableMixin) {
  editingSource: DateTimeDuration;

  @Prop({ default: false })
  isClearable: boolean;

  get from(): Date {
    return this.editingSource.from;
  }

  set from(source: Date) {
    this.writeProperty(s => s.from = source);
  }

  get to(): Date {
    return this.editingSource.to;
  }

  set to(source: Date) {
    this.writeProperty(s => s.to = source);
  }

  get isInverted(): boolean {
    return (!!this.to && !!this.from && (this.from > this.to));
  }
}
